import type { NextPage } from 'next'
import styles from './PostComponent.module.scss'
import { usePathname, useRouter } from 'next/navigation'
import Break from 'componentsUnits/break'
import ImageComponent from 'componentsUnits/image'
import RowComponent from 'componentsUnits/row'
import { deletePost, flagPost } from 'actions/post'
import { Size } from 'types/size'
import Button from 'componentsUnits/button'
import { EntryType, getHumanEntryType, likeEntry } from 'actions/general'
import EntryComponentContainer from '../../entryComponentContainer'
import Subtitle from 'componentsUnits/subtitle'
import { useEffect, useState } from 'react'
import { EntryDateIndex } from 'reducers/postReducer'
import UserInfoHeader from '../../userInfoHeader'
import { handleSharingUsingCapacitor } from 'helpers/general'
import { BASE_PATH } from 'actions/constants'
import { Option } from 'types/options'
import { Type } from 'types/type'
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks'
import { Divider } from '@mui/material'
import { isDev } from "app/general"
import { getEntryLikes } from 'helpers/entries'
import { updateToken } from 'actions/user'

interface Props {
  entryDateIndex: EntryDateIndex
}
const PostComponent: NextPage<Props> = ({ entryDateIndex }) => {
  const uid = useAppSelector((state) => state.userReducer?.user?.uid)
  const pathname = usePathname()

  const post = useAppSelector((state) => state.postReducer.posts)?.get(entryDateIndex.entryId)
  const router = useRouter()

  const goToPostPage = () => router.push('./post?id=' + entryDateIndex.entryId);
  const dispatch = useAppDispatch()

  const [options, setOptions] = useState<Option[]>([]);
  const deletePostClicked = (postId: string) => {
    confirm("Are you sure you want to delete this post?") &&
      dispatch(deletePost(postId, EntryType.POST))
  }

  useEffect(() => {
    if (post?.uid === uid) {
      setOptions([
        {
          label: "Delete",
          onClick: () => {
            deletePostClicked(entryDateIndex.entryId as string)
          }
        }
      ])
    } else {
      setOptions([

        {
          label: "Flag",
          onClick: () => { confirm("Are you sure you want to flag this event?") && dispatch(flagPost(entryDateIndex.entryId)) }
        }
      ])

    }
  }, [])

  if (!post) {
    isDev && console.log(`Cannot find Post ${entryDateIndex.entryId}`)
    return <></>
  }

  if (!uid) {
    isDev && console.log(`Cannot find User ${uid}`)
    return <></>
  }


  const likes = getEntryLikes(post)

  const entryType = getHumanEntryType(EntryType[post.entryType])

  return (
    <EntryComponentContainer
      type={post.parentType ? `${post.parentType} ${entryType}` : entryType}
      options={options}
    >
      <div className={styles.container}>
        <div className={styles.postSection}>
          <UserInfoHeader createdAt={post.createdAt}
            uid={post.uid} image={post.profile?.image}
            title={post.profile?.name ?? ""} />
          <Break size={Size.small} />

          {
            post.image && <div onClick={goToPostPage}>
              <RowComponent center fullWidth noPadding>
                <ImageComponent
                  fullWidth
                  image={post.image}
                  canClick
                />
              </RowComponent>
            </div>
          }

          {
            post.video && <div onClick={goToPostPage}>
              <RowComponent center fullWidth noPadding>
                <video width="100%" style={{ height: "50vh" }} controls>
                  <source src={post.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </RowComponent>
            </div>
          }

          <div className={styles.post} >
            {post.description}
          </div>

          {/* {(post.image || post.video) && <Break size={Size.small} />} */}
          {!(post.image || post.video) && <Break />}

          <RowComponent align fullWidth gap equalChildren>
            <RowComponent >
              <Subtitle alignLeft type={Type.t12} size={Size.xSmall} text={
                (!post.comments || post.comments.length === 0) ? `no comments`
                  :
                  post.comments.length > 20 ? `20+ comments`
                    :
                    `${post.comments.length} ${post.comments?.length === 1 ? "comment" : "comments"}`
              }
              />
            </RowComponent>
            <RowComponent alignRight>
              <Subtitle
                size={Size.xSmall}
                type={Type.t12}
                alignRight
                text={
                  likes > 0
                    ? `${likes} ${likes === 1 ? "like" : "likes"}`
                    : ``
                }
              />
            </RowComponent>
          </RowComponent>
          <Divider />
          <Break size={Size.small} />

          <RowComponent spaceAround fullWidth noPadding gap={false} center={false} >
            <Button
              size={Size.xSmall}
              type="8" text={post.likesIds && post.likesIds[uid] ? 'Unlike' : 'Like'}
              onClick={async () => {
                await dispatch(updateToken());
                dispatch(likeEntry(post.id, EntryType.POST, !(post.likesIds && post.likesIds[uid]))).then(() => {
                })
              }} />
            <Button size={Size.xSmall} type="8" text={'Comment'} onClick={goToPostPage} />
            <Button size={Size.xSmall} type="8" text={'Share'} onClick={() => {
              let path = BASE_PATH + "/post?id=" + post.id
              handleSharingUsingCapacitor(path, post.creatorName, post.description)
            }} />
          </RowComponent>

        </div >
      </div >
    </EntryComponentContainer >
  )
}

export default PostComponent

